import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import socket from "./socketIO";
import {
	DOC_APPROVED,
	DOC_APPROVING,
	DOC_APPROVING_FAILED,
	DOC_APPROVING_INITIALIZE, DOC_COMMENTED,
	DOC_COMMENTING,
	DOC_COMMENTING_FAILED,
	DOC_COMMENTING_INITIALIZE, DOC_SUBMITED,
	DOC_SUBMITTING,
	DOC_SUBMITTING_FAILED,
	DOC_SUBMITTING_INITIALIZE
} from "./types";

export const DocSubmitApproveCommentInitial=()=>(dispatch)=>
{
	dispatch({ type: DOC_SUBMITTING_INITIALIZE });
	dispatch({ type: DOC_APPROVING_INITIALIZE });
	dispatch({ type: DOC_COMMENTING_INITIALIZE});

}

export const docSubmit = (listdata) => (dispatch) => {
	dispatch({ type: DOC_SUBMITTING });
	storeNotification.addNotification({
		title: "Submit",
		message: "System is Submitting...",
		type: "success",
		insert: "top",
		container: "top-right",
		animationIn: ["animated", "fadeIn"],
		animationOut: ["animated", "fadeOut"],
		dismiss: {
			duration: 5000,
			onScreen: true,
		},
	});

	console.log("docSubmit data=", listdata);
	let formData = new FormData(); //formdata object

	var listItems = listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			if (response.error)
				return dispatch({
					type: DOC_SUBMITTING_FAILED,
					payload: response.error,
				});
			dispatch({ type: DOC_SUBMITED, payload: response.data._id });
			storeNotification.addNotification({
				title: "Submit!",
				message: "Succefull Submit Doc",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("response.data=", response.data);
		})
		.catch((error) => {
			console.log(error);
			storeNotification.addNotification({
				title: "Submit!",
				message: "failed to Submit Doc",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return dispatch({
				type: DOC_SUBMITTING_FAILED,
				payload: error,
			});
		});
};

export const docApprove = (listdata) => (dispatch) => {
	dispatch({ type: DOC_APPROVING });

	console.log("docApprove data=", listdata);
	let formData = new FormData(); //formdata object

	var listItems = listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			if (response.error)
				return dispatch({
					type: DOC_APPROVING_FAILED,
					payload: response.error,
				});
			dispatch({ type: DOC_APPROVED, payload: response.data._id });
			socket.emit("Notifications");

			storeNotification.addNotification({
				title: "Approve!",
				message: "Succefull Approved Doc",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("response.data=", response.data);
		})
		.catch((error) => {
			console.log(error);
			storeNotification.addNotification({
				title: "Approve",
				message: "Failed to Approve",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return dispatch({
				type: DOC_APPROVING_FAILED,
				payload: error,
			});
		});
};

export const docComment = (listdata) => (dispatch) => {
	dispatch({ type: DOC_COMMENTING });

	console.log("docApprove data=", listdata);
	let formData = new FormData(); //formdata object

	var listItems = listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			if (response.error)
				return dispatch({
					type: DOC_COMMENTING_FAILED,
					payload: response.error,
				});
			dispatch({ type: DOC_COMMENTED });
			storeNotification.addNotification({
				title: "Comment!",
				message: "Succefull Save Comment",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("response.data=", response.data);
		})
		.catch((error) => {
			console.log(error);
			return dispatch({
				type: DOC_COMMENTING_FAILED,
				payload: error,
			});
		});
};
